import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import get from 'lodash/get'
import { SelectType } from 'tennders-common/types/SelectType'

export type RadioSelectType = SelectType & {
  color ?: string,
  unitClass ?: string
}

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

type Props = Omit<DivProps, 'onChange'> & {
  onSet ?: (value: string|number|boolean) => void,
  value?: any,
  items ?: RadioSelectType[],
  labelClass?: string,
  eClass ?: string,
  label ?: string,
  disabled ?: boolean,
  horizontal ?: boolean,
  translationFile ?: string,
  vertical ?: boolean,
  onlyInput ?: boolean,
  className ?: string,
  radioGroupContainerClass ? : string,
  required ?: boolean,
  isBoolean?: boolean
}

const RadioGroup = (props : Props) => {
  const {
    onSet,
    required,
    className,
    value,
    items,
    disabled,
    horizontal,
    translationFile,
    isBoolean,
    ...rest
  } = props
  const { t } = useTranslation()

  const onFormChange = (e) => {
    if (onSet && e.target.checked) {
      if (isBoolean) {
        return onSet(e.target.value === 'true')
      }
      return onSet(e.target.value)
    }
    return false
  }

  return (
    <div className={className || `d-flex${horizontal ? ' column' : ' row'}`}>
      {items?.map((item) => (
        <div
          key={item.label + item.value + item.color}
          className={get(item, 'unitClass') ? get(item, 'unitClass') : 'mr-20'}
        >
          <input
            disabled={!!disabled}
            checked={`${value}` === `${item.value}` || `${value?.value}` === `${item.value}`}
            type="radio"
            onChange={onFormChange}
            value={item.value}
            required={required}
            className="form-radio"
          />
          <label style={{ color: item.color }}>
            {t(`${translationFile || 'variables'}:${item.label}`)}
          </label>
        </div>
      ))}
    </div>
  )
}

export default React.memo(RadioGroup)
